import { UserData } from "@quest-finance/quest-fe-shared/dist/auth/types/UserData";
import { PERMISSION_IAM } from "@quest-finance/quest-fe-shared/dist/iam/constants/permissions";

export const isAllowedAccess = (
  user: UserData,
  permissions: string[]
): boolean => {
  if (!user || user.permissions.length === 0) return false;
  if (permissions.length === 0) return false;

  const obj: Record<string, unknown> = {};

  for (let i = 0; i < user.permissions.length; i++) {
    if (!obj[user.permissions[i]]) {
      const element = user.permissions[i];
      obj[element] = true;
    }
  }

  for (let j = 0; j < permissions.length; j++) {
    if (obj[permissions[j]]) {
      return true;
    }
  }

  return false;
};

export const validatePermision = (
  userPermissions: string[],
  requiredPermissions: string[]
): boolean => {
  return userPermissions.some((userPermission) =>
    requiredPermissions.includes(userPermission)
  );
};

export const hasAccessToAssessmentApplications = (
  permissions: string[]
): boolean => {
  return validatePermision(permissions, [
    PERMISSION_IAM["ASSESSMENT.APPLICATION.READ"],
  ]);
};

export const hasAccessToAssessmentAccreditations = (
  permissions: string[]
): boolean => {
  return validatePermision(permissions, [
    PERMISSION_IAM["ASSESSMENT.ACCREDITATION.UPDATE"],
  ]);
};

export const hasAccessToClients = (permissions: string[]): boolean => {
  return validatePermision(permissions, [
    PERMISSION_IAM["IAM.CLIENT.UPDATE"],
    PERMISSION_IAM["IAM.CLIENT.LENDER.UPDATE"],
    PERMISSION_IAM["IAM.CLIENT.INTRODUCER.UPDATE"],
  ]);
};

export const hasAccessToUsers = (permissions: string[]): boolean => {
  return validatePermision(permissions, [
    PERMISSION_IAM["IAM.USER.UPDATE"],
    PERMISSION_IAM["IAM.USER.LENDER.UPDATE"],
    PERMISSION_IAM["IAM.USER.INTRODUCER.UPDATE"],
  ]);
};

export const hasAccessToRoles = (permissions: string[]): boolean => {
  return validatePermision(permissions, [PERMISSION_IAM["IAM.ROLE.UPDATE"]]);
};

export const hasAccessToMoveApplication = (permissions: string[]): boolean => {
  return validatePermision(permissions, [PERMISSION_IAM["APPLICATION.MOVE"]]);
};

export const hasAccessToPayment = (permissions: string[]): boolean => {
  return validatePermision(permissions, [PERMISSION_IAM["PAYMENT.READ"]]);
};

export const canViewLenders = (permissions: string[]): boolean => {
  return validatePermision(permissions, [
    PERMISSION_IAM["APPLICATION.LENDER.READ"],
  ]);
};

export const canCreateLenders = (permissions: string[]): boolean => {
  return validatePermision(permissions, [
    PERMISSION_IAM["APPLICATION.LENDER.CREATE"],
  ]);
};

export const canUpdateLenders = (permissions: string[]): boolean => {
  return validatePermision(permissions, [
    PERMISSION_IAM["APPLICATION.LENDER.UPDATE"],
  ]);
};
